var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avatar",class:_vm.colorClass},[(_vm.type === 'name')?[_vm._v(" "+_vm._s(_vm.firstname[0])+_vm._s(_vm.lastname[0])+" ")]:_vm._e(),(_vm.type === 'file')?_c('FileUpload'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }